<template>
  <div>
  <v-dialog
    :value="filterForm.openQuickViewMarketing"
    max-width="80%"
    persistent
  >
    <v-card class="text-center quick-view">
      <v-card-title class="text-sm-left font-weight-bold px-5">
        Thông tin cơ bản
        <v-divider style="border-color: #d2d2d2" class="mt-3 mb-3"></v-divider>
        <v-spacer />
        <v-icon aria-label="Close" @click="closeModal">mdi-close</v-icon>
      </v-card-title>
      <v-card-text class="px-9 pt-0">
        <v-row>
          <v-col cols="12" md="5" class="border-right" style="text-align: left">
            <v-row style="margin-top: -15px">
              <v-col cols="12" md="12" class="pa-0">
                <div class="d-flex justify-space-between mb-3 mt-2">
                  <span class="font-weight-bold">
                    {{ codeAndMobile }}
                    <v-tooltip
                      v-if="checkContactSources(dataContact.contactSources)"
                      bottom
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn
                          size="16"
                          width="20"
                          height="20"
                          class="mr-1"
                          icon
                          small
                          color="info"
                          v-on="on"
                        >
                          <v-icon size="16">mdi-facebook-messenger</v-icon>
                        </v-btn>
                      </template>
                      <span>Nhắn tin</span>
                    </v-tooltip>
                  </span>
                  <span>
                  <v-btn
                    @click="requiredSupport(dataContact.code)"
                    small color="#FFC700">  <v-icon size="16">mdi-headphones</v-icon> <span class="ml-1">Yêu cầu hỗ trợ</span></v-btn>
                  </span>
                  <!-- <v-btn v-if="checkConditionT4NT5(_.get(this.dataContact, 'contactStatus.type', '')) && !checkIncludesT4NT5(_.get(this.dataContact, 'contactStatus.type', ''))" @click="createOrder(dataContact.id)" small color="primary">Tạo đơn hàng </v-btn> -->
                  <!-- <v-btn @click="createOrder(dataContact.id)" small color="primary">Tạo đơn hàng </v-btn> -->
                  <v-btn
                    v-if="checkAuthorization('order_create') && checkNotIncludesM(dataContact.contactStatus.type)"
                    @click="createOrder(dataContact.id)"
                    small
                    color="primary"
                    >Tạo đơn hàng</v-btn
                  >
                  <!-- <v-btn
                    v-if="checkAuthorization('order_create') && checkNotIncludesM(dataContact.contactStatus.type)"
                    @click="createOrderNew(dataContact.id)"
                    small
                    color="primary"
                    >Tạo đơn hàng</v-btn> -->
                </div>
              </v-col>
              <v-col cols="12" md="6" class="pa-0">
                <span
                  @click="clickContactDetail(dataContact.id)"
                  style="cursor: pointer"
                >
                  <v-icon color="primary">mdi-account</v-icon>
                  <span style="margin-left: 5px">{{
                    _.get(dataContact, "contactFullName", "") === _.get(this.dataContact, "mobile", "") ? maskedPhoneNumber(_.get(dataContact, "contactFullName", "")) : _.get(dataContact, "contactFullName", "")
                  }}</span>
                </span>
              </v-col>
              <v-col cols="12" md="6" class="pa-0">
                <v-menu offset-y v-if="dataContact.contactType == 'main'">
                  <template v-slot:activator="{ on: on, attrs }">
                    <v-btn
                      size="16"
                      width="20"
                      height="20"
                      class="mr-1"
                      icon
                      small
                      color="success"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon size="16">mdi-phone</v-icon>
                    </v-btn>
                    <span v-on="on" style="cursor: pointer"
                      >Gọi cho khách hàng</span
                    >
                  </template>
                  <v-list>
                    <v-list-item
                      @click="clickExecuteCall(dataContact, dataContact.mobile, true)"
                      class="main-mobile"
                    >
                      <v-list-item-title>{{
                          maskedPhoneNumber(dataContact.mobile)
                      }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      v-for="(phone, index) in dataContact.phoneRelated"
                      :key="index"
                      @click="clickExecuteCall(dataContact, phone, true)"
                      class="sub-mobile"
                    >
                      <v-list-item-title>{{ maskedPhoneNumber(phone)}}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
                <v-menu offset-y v-if="dataContact.contactType == 'main' && !isNormalCall && listCallOptions && listCallOptions.length > 0">
                  <template v-slot:activator="{ on: menu, attrs }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on: tooltip }">
                        <v-btn
                            size="18"
                            width="25"
                            height="25"
                            class="mr-1"
                            icon
                            small
                            color="#C08B00"
                            v-bind="attrs"
                            v-on="{...tooltip, ...menu}"
                        >
                          <v-icon size="20">mdi-swap-horizontal-circle</v-icon>
                        </v-btn>
                      </template>
                      <span>Gọi cho khách hàng</span>
                    </v-tooltip>
                  </template>
                  <v-list>
                    <v-list-item
                        v-for="(option, index) in listCallOptions" :key="index"
                        :class="selectedCallOptions.type === option.type === 'auto' ?  'main-mobile' : selectedCallOptions.brandnameCode === option.brandnameCode ? 'main-mobile' : 'sub-mobile'"
                    >
                      <v-menu offset-x v-if="dataContact.contactType == 'main'">
                        <template v-slot:activator="{ on: on, attrs }">
                          <v-list-item-title
                              v-bind="attrs"
                              v-on="on"
                              @click="SET_SELECTED_CALL_OPTION(option)">Gọi {{ option.type === 'auto' ? 'Auto' : option.brandnameCode}}
                          </v-list-item-title>
                        </template>
                        <v-list>
                          <v-list-item
                              @click="clickExecuteCall(dataContact, dataContact.mobile)"
                              class="main-mobile"
                          >
                            <v-list-item-title>{{dataContact.mobile}}</v-list-item-title>
                          </v-list-item>
                          <v-list-item
                              v-for="(phone, index) in dataContact.phoneRelated"
                              :key="index"
                              @click="clickExecuteCall(dataContact, phone)"
                              class="sub-mobile"
                          >
                            <v-list-item-title>{{phone}}</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </v-list-item>
                  </v-list>
                </v-menu>
                <span @click="clickExecuteCall(dataContact, dataContact.mobile, true)" style="cursor: pointer;" v-if="dataContact.contactType != 'main'">
                  <v-btn style="margin-left: -5px"  icon small color="success" dark>
                      <v-icon>mdi-phone</v-icon>
                  </v-btn>
                  <span>Gọi cho khách hàng</span>
                  <v-menu offset-y v-if="!isNormalCall && listCallOptions && listCallOptions.length > 0">
                  <template v-slot:activator="{ on: menu, attrs }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on: tooltip }">
                        <v-btn
                            size="18"
                            width="25"
                            height="25"
                            class="mr-1"
                            icon
                            small
                            color="#C08B00"
                            v-bind="attrs"
                            v-on="{...tooltip, ...menu}"
                        >
                          <v-icon size="20">mdi-swap-horizontal-circle</v-icon>
                        </v-btn>
                      </template>
                      <span>Gọi cho khách hàng</span>
                    </v-tooltip>
                  </template>
                  <v-list>
                    <v-list-item
                        v-for="(option, index) in listCallOptions" :key="index"
                        @click="setSelectedCallOption(dataContact, dataContact.mobile, option)"
                        :class="selectedCallOptions.type === option.type === 'auto' ?  'main-mobile' : selectedCallOptions.brandnameCode === option.brandnameCode ? 'main-mobile' : 'sub-mobile'"
                    >
                      <v-list-item-title>Gọi {{ option.type === 'auto' ? 'Auto' : option.brandnameCode}}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
                </span>
              </v-col>
              <v-col cols="12" md="6" class="pa-0">
                <span
                  @click="clickHistoryCall(dataContact.mobile)"
                  style="cursor: pointer"
                >
                  <v-btn style="margin-left: -5px" icon small color="grey" dark>
                    <v-icon>mdi-file-music</v-icon>
                  </v-btn>
                  <span>Lịch sử cuộc gọi</span>
                </span>
              </v-col>
              <v-col cols="12" md="6" class="pa-0">
                <span
                  @click="clickNewAppointment(dataContact)"
                  v-if="
                    checkConditionT4NT5(
                      _.get(this.dataContact, 'contactStatus.type', '')
                    )
                  "
                  style="cursor: pointer"
                >
                  <v-btn style="margin-left: -5px" icon small color="warning">
                    <v-icon>mdi-timer</v-icon>
                  </v-btn>
                  <span>Tạo lịch hẹn</span>
                </span>
              </v-col>
              <v-col
                  v-if="(checkAuthorization('order_create') || checkAuthorization('admin-search_read'))"
                  cols="12" md="6" class="pa-0">
                      <span
                          @click="viewActiveCodes(dataContact)"
                          style="cursor: pointer;">
                          <v-btn style="margin-left: -5px"  icon small color="blue">
                            <v-icon>mdi-codepen</v-icon>
                          </v-btn>
                        <span>Mã kích hoạt</span>
                      </span>
              </v-col>
              <v-col cols="12" md="6" class="pa-0" v-if="dataContact.lastExamAt">
                <span
                    @click="viewLogDGNL(dataContact)"
                    style="cursor: pointer;">
                    <v-btn style="margin-left: -5px" icon small color="red">
                      <v-icon>mdi-note-text</v-icon>
                    </v-btn>
                  <span>Thi ĐGNL</span>
                </span>
              </v-col>
              <v-col
                  cols="12" md="6" class="pa-0">
                <span
                    @click="showModalZaloZns"
                    style="cursor: pointer;">
                    <v-btn style="margin-left: -5px"  icon small color="blue">
                      <v-icon>mdi-message-processing</v-icon>
                    </v-btn>
                  <span>Gửi tin tự động</span>
                </span>
              </v-col>
              <v-col
                cols="12"
                md="12"
                class="pa-0"
                v-if="dataContact.appointment"
              >
                <span style="cursor: pointer">
                  <v-btn
                    style="margin-left: -5px"
                    icon
                    small
                    color="secondary"
                    dark
                  >
                    <v-icon>mdi-bell</v-icon>
                  </v-btn>
                  <span class="mr-2 appointment-time-wrapper">
                    <span
                      @click="editAppointment(dataContact)"
                      style="cursor: pointer"
                      >{{
                        checkAppointmentTime(dataContact.appointment.date)
                      }}</span
                    >&nbsp;
                  </span>
                  <v-menu
                    offset-y
                    v-if="
                      statusCallCenter() && dataContact.contactType == 'main'
                    "
                  >
                    <template v-slot:activator="{ on: menu, attrs }">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on: tooltip }">
                          <v-btn
                            min-width="22px !important"
                            height="22"
                            class="btn-notification"
                            dark
                            small
                            v-bind="attrs"
                            v-on="{ ...tooltip, ...menu }"
                          >
                            <v-icon class="icon-flipped" size="16"
                              >mdi-phone</v-icon
                            >
                          </v-btn>
                        </template>
                        <span>Thực hiện lịch hẹn</span>
                      </v-tooltip>
                    </template>
                    <v-list>
                      <v-list-item
                        @click="
                          showAppoimentAction(dataContact, dataContact.mobile)
                        "
                        class="main-mobile"
                      >
                        <v-list-item-title>{{
                          dataContact.mobile
                        }}</v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        v-for="(phone, index) in dataContact.phoneRelated"
                        :key="index"
                        @click="showAppoimentAction(dataContact, phone)"
                        class="sub-mobile"
                      >
                        <v-list-item-title>{{ phone }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <v-tooltip v-else-if="statusCallCenter()" bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        min-width="22px !important"
                        height="22"
                        class="btn-notification"
                        dark
                        small
                        v-on="on"
                        @click="
                          showAppoimentAction(dataContact, dataContact.mobile)
                        "
                      >
                        <v-icon class="icon-flipped" size="16"
                          >mdi-phone</v-icon
                        >
                      </v-btn>
                    </template>
                    <span>Thực hiện lịch hẹn</span>
                  </v-tooltip>
                </span>
              </v-col>
              <!--              <v-col cols="12" md="6" class="pa-0">-->
              <!--                <v-icon color="blue" style="margin-right: 4px;">mdi-filter</v-icon>-->
              <!--                <span>Mối quan hệ: {{dataContact.contactStatus.name}}</span>-->
              <!--              </v-col>-->
              <v-col cols="12" md="12" class="pa-0">
              <b style="font-size:14px;font-weight:700;line-height:20px">TAG ĐÍNH KÈM</b>
              <div class="pa-0">
                <div class="mt-2 mr-3 pa-3 class-list">
                  <v-chip
                      class="ma-2"
                      outlined
                      style="height: 28px"
                      v-for="(tag, index) in tagByContact"
                      :key="index"
                      :color="tag.tagColor"
                  >
                  <span @click="openLink(tag)" style="cursor: pointer;">
                    {{tag.tagName}}
                    <v-icon v-ripple right style="font-size: 14px;">
                      {{tag.tagIcon}}
                    </v-icon>
                    </span>
                  </v-chip>
                </div>
              </div>
            </v-col>
              <v-col cols="12" md="12" class="pa-0 mt-3 pr-3">
                <v-row>
                  <v-col>
                    <v-text-field
                      :value="formatDate(dataContact.assignedAt)"
                      label="Ngày phân bổ contact"
                      readonly
                      disabled
                    />
                  </v-col>
                  <v-col>
                    <common-select-user
                      :readonly="
                        !checkAuthorization('contact_change_user_read')
                      "
                      v-model="userId"
                      :items="getSelectUser"
                      label="Người phụ trách"
                      color="primary"
                      item-text="fullName"
                      item-value="id"
                      :changeUser="changeSelectUser"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-autocomplete
                      :readonly="
                        !checkAuthorization('contact_change_status_read') ||
                        !checkConditionT4NT5(
                          _.get(this.dataContact, 'contactStatus.type', '')
                        )
                      "
                      v-model="statusId"
                      :items="selectContactStatusList"
                      item-text="name"
                      item-value="id"
                      label="Chuyển mối quan hệ"
                      @change="changeSelectStatus"
                    />
                  </v-col>
                  <v-col>
                    <v-text-field
                      :value="
                        formatPrice(
                          +_.get(dataContact, 'order.totalValue', 0)
                        ) + ' VNĐ'
                      "
                      label="Tổng giá trị tất cả đơn hàng"
                      readonly
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-text-field
                      :value="formatDate(dataContact.importUpdatedAt)"
                      label="Ngày đăng ký gần nhất"
                      readonly
                      disabled
                    />
                  </v-col>
                  <v-col>
                    <common-select-user
                      v-if="getSelectUserMarketing.length"
                      :readonly="
                        !checkAuthorization('contact_change_user_read')
                      "
                      v-model="userMarketingName"
                      :items="getSelectUserMarketing"
                      label="Nhân viên marketing"
                      color="primary"
                      item-text="fullName"
                      item-value="fullName"
                      :changeUser="changeSelectUserMarketing"
                    />
                    <v-text-field
                      v-else
                      :value="userMarketingName"
                      label="Nhân viên marketing"
                      readonly
                      disabled
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="6" align="center" justify="space-around">
                    <v-btn
                      v-if="checkAuthorization('order_create')"
                      @click="createOrder(dataContact.id)"
                      small
                      color="primary"
                      >Chiến dịch marketing</v-btn
                    >
                  </v-col>
                  <v-col cols="12" sm="6" align="center" justify="space-around">
                    <v-btn
                      v-if="(checkAuthorization('order_create') || checkAuthorization('admin-search_read'))"
                      @click="viewInteractions"
                      small
                      color="primary"
                      >Đo lường tương tác({{dataInteraction.cumulative_point ? dataInteraction.cumulative_point : 0}})</v-btn
                    >
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" md="7">
            <validation-observer v-slot="{ handleSubmit }">
              <v-row style="margin-top: -30px">
                <v-col
                  cols="12"
                  md="12"
                  style="text-align: right"
                  v-if="showNote && tab != 1"
                >
                  <validation-provider
                    v-slot="{ errors }"
                    name="Thông tin ghi chú"
                    :rules="{ required: reloadCreateNote, max: 255 }"
                  >
                    <v-textarea
                      label="Nhập ghi chú"
                      rows="3"
                      v-model="note"
                      :error-messages="errors"
                      @keydown.enter.exact.prevent="
                        handleSubmit(clickCreateHistoryContact)
                      "
                    />
                  </validation-provider>
                  <v-btn
                    class="d-flex"
                    small
                    @click.prevent="handleSubmit(clickCreateHistoryContact)"
                    color="primary"
                    style="float: left"
                    >Tạo</v-btn
                  >
                  <v-btn
                    v-show="
                      ((dataContact.statusId >= 4 &&
                        dataContact.statusId <= 13) ||
                        dataContact.statusId == 49) &&
                      parseInt(dataContact.beforeSupport)
                    "
                    small
                    @click="returnToBackStatus()"
                    color="primary"
                    style="float: right"
                    >Đã hỗ trợ CSKH</v-btn
                  >
                </v-col>
                <v-tabs v-model="tab" grow>
                  <v-tabs-slider></v-tabs-slider>

                  <v-tab v-for="(item, key) in tabs" :key="key"
                         :style="(item == 'Vận hành' && (filterForm.typeId == 3 || showOperateByTestType)) ? {'display':'none'} : {'display':'block'}"
                  >
                    {{ item }}
                  </v-tab>

                  <v-tab-item v-for="(item, key) in tabs" :key="key">
                    <v-col
                      cols="12"
                      md="12"
                      class="pt-0 mt-4 contact-history-table--wrapper"
                      :style="(tab == 1 && (filterForm.typeId == 3 || showOperateByTestType)) ? {'display':'none'} : {'display':'block'}"
                    >
                      <contact-history-table
                        :style="(tab == 1 && (filterForm.typeId == 3 ||showOperateByTestType)) ? {'visibility':'hidden'} : {'visibility':'visible'}"
                        :sheduleInfo="sheduleInfo"
                        :tutorNoteHistory="tutorNoteHistory"
                        :contactHistorys="contactHistorys"
                        :orderList="orderList"
                        :showSTT="false"
                        @deleteContactHistory="deleteContactHistory"
                        :currentUserId="currentUserId"
                        @updateContactHistory="updateContactHistory"
                        @setTrialSuccess="getInterviewsDetail"
                        :tab="parseInt(tab)"
                        :contactQuickviewDetail="contactQuickviewDetail"
                        :listTransferOrder="listTransferOrder"
                        :totalListOrder="totalListOrder"
                        :curriculums="curriculums"
                        :typeId="filterForm.typeId"
                        :schoolLevelId="filterForm.schoolLevelId"
                      />
                    </v-col>
                  </v-tab-item>
                </v-tabs>
                <v-col v-if="totalItem > 300" cols="12" md="12" class="pt-0">
                  <v-btn color="success" @click="clickViewHistoryContact"
                    >Xem thêm</v-btn
                  >
                </v-col>
              </v-row>
            </validation-observer>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <modal-count-interaction
      v-if="isActiveCountInteractions"
      @closePopUp="closePopupInteractions"
      :isActiveCountInteractions="isActiveCountInteractions"
      :dataInteraction="dataInteraction"
      :totalItemActionLogs.sync="totalItemActionLogs"
      :currentPage.sync="currentPage"
    />

    <modal-active-codes
        v-if="isActiveCodes"
        :isActiveCodes="isActiveCodes"
        :activeCodesCustomer="activeCodesCustomer"
        :dataContact="dataContact"
    />
    <modal-thi-dgnl
        v-if="isPopupDGNL"
        :isPopupDGNL="isPopupDGNL"
        :dataDGNL="dataDGNL"
        @closeModal="closePopupDGNL"
    />
    <modal-zalo-zns
        v-if="isShowZaloZns"
        :isShowZaloZns="isShowZaloZns"
        :dataContact="dataContact"
    />
  </v-dialog>
  <v-dialog
    v-if="showIeltsOnboarding"
    v-model="showIeltsOnboarding"
    content-class="show-try-lession"
    width="800"
  > 
    <ModalOnBoadingIelts :listChild="contactQuickviewDetail.childCustomer"/>
  </v-dialog>
  <ModalInfoTryLession :listChild="listChild" :show="showPopupTryLession" @closeDialog="closeDialogTryLession"/>
  </div>
</template>

<script>
import {maskedPhoneNumber} from "@/helpers/regex";
import moment from 'moment';
import TokenService from "../../../helpers/token";
import ContactHistoryTable from "./ContactHistoryTable";
import handleSchedule from "@/mixins/handleSchedule";
import {
  contactCreator, moduleSchoolLevel, moduleTypes,
  namesOrderContactStatusTc,
  ORDER_DEPOSIT_TYPE,
  ORDER_FINISH_TYPE,
} from "../../../helpers/constants";
import { showFbMessengerIcon } from "@/helpers/utils";
import RepositoryFactory from "../../../repositories/RepositoryFactory";
import ModalCountInteraction from "./ModalCountIeraction";
import ModalActiveCodes from "./ModalActiveCodes";
import ModalThiDgnl from "./ModalThiDgnl";
import ModalZaloZns from "./ModalZaloZns";
import ModalInfoTryLession from './ModalInfoTryLession.vue'
import ModalOnBoadingIelts from './ModalOnBoadingIelts.vue'
import {mapMutations, mapState} from "vuex";
const ContactRepository = RepositoryFactory.get("contact");
const OrderRepository = RepositoryFactory.get("order");
const CoreActionsLogRepository = RepositoryFactory.get("core_actions_log");
const TutorTestRepository = RepositoryFactory.get("tutorTest");

export default {
  mixins: [handleSchedule],
  components: {
    ContactHistoryTable,
    ModalCountInteraction,
    ModalActiveCodes,
    ModalThiDgnl,
    ModalZaloZns,
    ModalInfoTryLession,
    ModalOnBoadingIelts,
  },
  name: "ContactStatusFilterForm",
  props: {
    dataContact: {
      default: () => ({}),
    },
    filterForm: {
      default: () => ({}),
    },
    contactStatusList: {
      type: Array,
      default: () => [],
    },
    users: {
      type: Array,
      default: () => [],
    },
    usersMarketing: {
      type: Array,
      default: () => [],
    },
    contactQuickviewDetail:{
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      listChild: [],
      showPopupTryLession: false,
      showIeltsOnboarding: false,
      isStatusChange: false,
      statusId: 0,
      note: "",
      totalItem: 0,
      contactHistorys: [],
      orderList: [],
      reloadCreateNote: true,
      userId: 0,
      showNote: true,
      currentUserId: "",
      tabs: ["Trao đổi", 'Vận hành', "Log", "Vận đơn log", "Đơn hàng","Lịch sử hỗ trợ"],
      tab: 0,
      userMarketingName: "",
      isActiveCountInteractions: false,
      dataInteraction: {
        listActions: [],
        cycle_point: 0,
        cumulative_point: 0,
      },
      tutorNoteHistory: [],
      sheduleInfo: null,
      activeCodesCustomer: [],
      isActiveCodes: false,
      actionLogTypeList: [],
      mapNamePointActionLog: {},
      totalItemActionLogs: null,
      currentPage: 1,
      dataTime: {},
      listTransferOrder: [],
      totalListOrder: [],
      listCallOptions: [],
      isPopupDGNL: false,
      dataDGNL: [],
      curriculums: [],
      tagByContact: [],
      isShowZaloZns: false
    };
  },
  async created() {
    this.getListCallOption();
    await this.getActionLogTypeList();
    this.getDetailContact();
    this.getContactHistory();
    this.getCurriculums();
    this.isStatusChange = false;
    this.statusId = this.dataContact.statusId;
    this.userId = _.get(this.dataContact, "user.id", "");
    // this.listChild = this.dataContact.customers;
    this.checkIdsChild(this.dataContact.customers)
    this.userMarketingName = _.get(this.dataContact, "userMarketingName", "");
    this.currentUserId = await TokenService.getId();
    this.checkShowNote();
    this.getTagsContact();
    Bus.$on("reset-fetch-quick-view-history", () => {
      this.getContactHistory();
    });
    Bus.$on('reload-interview', () => {
      this.getInterviewsDetail()
      this.getNote()
    });
    Bus.$on('reload-contactHistory',()=>{
      this.getContactHistory()
    })

    Bus.$on('close-active-code-modal', () => {
      this.isActiveCodes = false
    });
    Bus.$on('get-detail-contact-quickview', (dateTime) => {
      this.currentPage = 1;
      this.dataTime = dateTime;
    });
    Bus.$on('count-list-filter', (dateTime) => {
      this.getDetailContact(dateTime?.month, dateTime?.year);
    })
    Bus.$on('close-zalo-zns-modal', () => {
      this.isShowZaloZns = false
    });
  },
  beforeDestroy() {
    Bus.$off('get-detail-contact-quickview');
    Bus.$off('count-list-filter');
    Bus.$off('close-zalo-zns-modal');
  },
  computed: {
    ...mapState(['isCallWithBrandName', 'selectedCallOptions']),
    getContact() {
      return {
        contactId: this.dataContact.id,
        fullName: this.dataContact.fullName,
      };
    },
    getSelectUser() {
      if (this.isManager() || this.checkAuthorization("contact_view_all")) {
        return this.users;
      }
      const dataUser = TokenService.getUser() || {};
      const userId = _.get(dataUser, "id", "");
      if (this.isStaff()) {
        return this.users.filter((data) => data.id == userId);
      }
      return this.users.filter(
        (data) =>
          data.departmentId === dataUser.departmentId ||
          dataUser.listDepartmentIds.includes(data.departmentId)
      );
    },

    getSelectUserMarketing() {
      if (this.isManager() || this.checkAuthorization("contact_view_all")) {
        return this.usersMarketing;
      }
      const dataUser = TokenService.getUser() || {};
      const userId = _.get(dataUser, "id", "");
      if (this.isStaff()) {
        return this.usersMarketing.filter((data) => data.id == userId);
      }
      return this.usersMarketing.filter(
        (data) =>
          data.departmentId === dataUser.departmentId ||
          dataUser.listDepartmentIds.includes(data.departmentId)
      );
    },
    requiredNote() {
      return !_.trim(this.note) !== "";
    },
    codeAndMobile() {
      let phoneNumber = _.get(this.dataContact, "mobile", "");
      if (this.filterForm.typeId === moduleTypes.TU_HOC && this.filterForm.schoolLevelId === moduleSchoolLevel.TH){
        phoneNumber = maskedPhoneNumber(phoneNumber);
      }
      return (
        _.get(this.dataContact, "code", "") +
        " - " +
        phoneNumber
      );
    },
    selectContactStatusList() {
      const selectType =
          this.filterForm.store === 'T' ? ['T1', 'T2', 'T3']
              : this.filterForm.store === 'C' ? ['C1', 'C2', 'C3']
              : this.filterForm.store === 'G' ? ['G1', 'G2', 'G3'] : ['M1', 'M2', 'M3', 'M4', 'M5'];
      // if (this.isStaff() && !this.checkAuthorization('contact_view_all')) {
      //   selectType.shift();
      // }
      const contactStatusList = [];
      const checkType = {};
      this.contactStatusList.forEach((contactStatus) => {
        const typeContactStatus = contactStatus.type;
        if (
          selectType.includes(typeContactStatus.slice(-2)) ||
          _.get(contactStatus, "id", "") == this.statusId
        ) {
          if (!checkType[typeContactStatus]) {
            checkType[typeContactStatus] = true;
            if (contactStatusList.length > 0) {
              contactStatusList.push({
                divider: true,
              });
            }
            contactStatusList.push({
              header: typeContactStatus,
              style: "color: red;",
            });
          }
          contactStatusList.push(contactStatus);
        }
        for (let i = 0; i < contactStatusList.length; i++) {
          // if(contactStatusList[i].type == "T0" || contactStatusList[i].type == "C0" || contactStatusList[i].header == "T0" || contactStatusList[i].header == "C0")
          // {
          //   contactStatusList.splice(i,1);
          // }
        }
      });
      return contactStatusList;
    },
    isNormalCall(){
      const user = TokenService.getUser();
      return this.checkAuthorization('auto-call_read') || user.username === 'tructoi' || user.username === 'tructoi_caresoft' || user.username === 'Tructongdai_ODS' || user.callcenter_id == 1 || !this.isCallWithBrandName
    },
    showOperateByTestType() {
      if (!this.curriculums) return true;
      if (!this.curriculums?.length) return true;
      return this.curriculums?.every(item => !item.test_type.length);

    }
  },
  watch: {
    tab: {
      handler() {
        this.getContactHistory();
      },
    },
  },
  methods: {
    maskedPhoneNumber,
    async checkIdsChild(items) {
      let user_ids = items.filter(item => item.vhUserId).map(item => item.vhUserId)
      let res = await ContactRepository.checkIdInforTryLesson({
        user_ids
      })
      let userIdsValid = res.data.filter(item => item.has_data_trial_report).map(item => item.user_id);
      this.listChild  = items.filter(item => userIdsValid.includes(item.vhUserId))
    },
    closeDialogTryLession(){
      this.showPopupTryLession = false
    },
    requiredSupport(customerCode) {
      const routeData = this.$router.resolve({
        path: '/customer-support-v2',
        query: {
          tab:0,
          customerCode,
        }
      });
      window.open(routeData.href, '_blank');
    },
    ...mapMutations(['SET_SELECTED_CALL_OPTION', 'SET_DEFAULT_TYPE_AUTO']),
    setSelectedCallOption(dataContact, phone, option){
      this.SET_SELECTED_CALL_OPTION(option)
      this.clickExecuteCall(dataContact, phone)
    },
    async getDetailContact(month = null, year = null) {
      const result = {
        listActions: [],
      };

      const params = {
        contactId: this.dataContact.id,
        limit: 10,
        page: this.currentPage - 1,
      };
      if (month && year){
        params.month = month
        params.year = year
      }else{
        params.month = this.dataTime.month
        params.year = this.dataTime.year
      }
      const loader = this.$loading.show();
      const res = await CoreActionsLogRepository.detail(params);
      loader.hide();
      if (res.error) {
        return (this.dataInteraction = []);
      }
      result.cycle_point = _.get(res, "data.points.cyclePoint", 0);
      result.cumulative_point = _.get(res, "data.points.cumulativePoint", 0);
      _.get(res, "data.actionLogs.data").forEach((e) => {
        result.listActions.push({
          create_date: _.get(e, "create_date", "Lỗi hệ thống"),
          interaction: _.get(e, "action", "Lỗi hệ thống"),
          fullName: _.get(e, "fullName", "Lỗi hệ thống"),
          point: this.mapNamePointActionLog[e.action] ? this.mapNamePointActionLog[e.action] : null
        });
      });
      this.totalItemActionLogs = res.data.actionLogs.totalItem;

      return (this.dataInteraction = result);
    },
    async getListCallOption() {
      if(this.listCallOptions.length < 1 ){
        let responseListCallOptions = await ContactRepository.getCallOptions(this.dataContact.id)
        if(responseListCallOptions && responseListCallOptions.success) {
          this.listCallOptions = responseListCallOptions.data
        }
      }
    },
    closePopupInteractions(variable) {
      this.isActiveCountInteractions = variable;
    },
    viewInteractions() {
      this.isActiveCountInteractions = true;
    },
    clickAppointmentList(mobile) {
      const routeData = this.$router.resolve({
        name: "Appointment",
        query: {
          keyword: mobile,
        },
      });
      window.open(routeData.href, "_blank");
    },
    clickContactDetail(contactId) {
      const routeData = this.$router.resolve({
        name: "ContactDetail",
        params: {
          id: contactId || 0,
        },
      });
      window.open(routeData.href, "_blank");
    },
    createOrder(contactId) {
      const id = contactId;
      // this.$router.push({
      //   name: 'OrderCreate',
      //   params: { id: id }
      // });
      let routeData = this.$router.resolve({
        name: "OrderCreate",
        params: {
          id: id,
        },
      });
      window.open(routeData.href, "_blank");
    },
    createOrderNew(contactId) {
      const id = contactId;
      let routeData = this.$router.resolve({
        name: "UpdateContactInfo",
        params: {
          id: id,
        },
      });
      window.open(routeData.href, "_blank");
    },
    clickViewHistoryContact() {
      const contactId = this.dataContact.id;
      this.$router.push({
        name: "ContactHistory",
        params: {
          id: contactId || 0,
        },
      });
    },
    async getContactHistory() {
      const contactId = this.dataContact.id;
      let params = {
        limit: 300,
        page: 0,
      };
      if (this.tab == 0) {
        params.action = "NOTE";
      } else {
        params.ne_action = ['NOTE', 'OPERATION']
      }
      if (this.tab < 3 && this.tab != 1) {
        this.loading = true;
        const loader = this.$loading.show();
        const response = await ContactRepository.getContactHistorys(
          params,
          contactId
        );
        loader.hide();
        this.loading = false;
        if (response.success) {
          this.contactHistorys = _.get(response, "data", []).map((contact) => {
            const contactTemp = contact;
            contactTemp.creatorFullName = _.get(
              contactTemp,
              "creator.fullName",
              null
            );
            if (!contactTemp.creatorFullName) {
              contactTemp.creatorFullName =
                contactCreator[contact.createdBy] || "";
            }
            contactTemp.editable = false;
            return contactTemp;
          });
          this.totalItem = response.totalItem;
        } else {
          this.$swal({
            type: "error",
            title: "Lỗi !",
            text: _.get(response, "message", ""),
          });
          this.contactHistorys = [];
          this.totalItem = 0;
        }
      } else if (this.tab == 3) {
        this.loading = true;
        const loader = this.$loading.show();
        const response = await ContactRepository.getContactHistorysTransportNote(
          params,
          contactId
        );
        loader.hide();
        this.loading = false;
        if (response.success) {
          this.contactHistorys = this.contactHistorys = _.get(
            response,
            "data",
            []
          ).map((contact) => {
            const contactTemp = contact;
            contactTemp.creatorFullName = _.get(
              contactTemp,
              "user.full_name",
              ""
            );
            return contactTemp;
          });
          this.totalItem = response.totalItem;
        } else {
          this.$swal({
            type: "error",
            title: "Lỗi !",
            text: _.get(response, "message", ""),
          });
          this.contactHistorys = [];
          this.totalItem = 0;
        }
      }else if(this.tab === 4) {
        params.contactId = contactId;
        params.code = '';
        this.loading = true;
        const loader = this.$loading.show();
        const response = await OrderRepository.listV2({
          ...params,
          fromQuickView: 1
        });
        const responseTutor = await OrderRepository.getTransferOrderStudents(contactId)
        loader.hide();
        this.loading = false;
        if(responseTutor.success) {
           this.listTransferOrder = _.get(responseTutor, 'data', []);
        }
        if (response.success) {
          this.orderList = _.get(response, 'data.data', []);
          this.totalItem = response.totalItem;
        } else {
          this.$swal({
            type: 'error',
            title: 'Lỗi !',
            text: _.get(response, 'message', '')
          });
          this.orderList = [];
          this.totalItem = 0;
        }
        const totalListOrder = await Promise.all(this.orderList.concat(this.listTransferOrder).map(async (s) => {
          let depositLabel = null;
          let hasFinishOrder = null;
          let isAllTheSameUserCreate = null;
          if (s.isGroupOrder) {
            let depositOrder = s.listOrders.find(item => item.orderType == ORDER_DEPOSIT_TYPE);
            if (depositOrder) {
              s.code = depositOrder.code;
              s.depositOrderId = depositOrder.id;
            }

            for (let i =  0; i < s.listOrders.length; i++) {
              // call api trail
              const trailData = await OrderRepository.getTrailOfOrder(s.listOrders[i].id)

              let trailProduct = [];
              if (trailData.success) {
                trailProduct = _.get(trailData, 'data.trailProductData', [])
              }
              s.listOrders[i].isTrail = trailProduct.length ? true : false;
              // console.log('s.listOrders[i].id trailProduct: ', s.listOrders[i].id, trailProduct.length)

              s.listOrders[i].products = s.listOrders[i].products.map(prod => {
                let trailProductFind = trailProduct.find(trailP => trailP.productId == prod.productId && trailP.customerId == prod.customerId)
                let numberLessons = trailProductFind ? s.listOrders[i].orderType == ORDER_DEPOSIT_TYPE ? trailProductFind.trailLessons : +(trailProductFind.numberOfSection - trailProductFind.trailLessons) : null;
                return {
                  ...prod,
                  numberLessons
                }
              })

              s.listOrders[i].combos = s.listOrders[i].combos.map(prod => {
                let numberLessons = 0;
                return {
                  ...prod,
                  numberLessons
                }
              })
            }
            depositLabel = this.getDepositLabel(s.listOrders);
            hasFinishOrder = s.listOrders.findIndex(e => e.orderType == ORDER_FINISH_TYPE) > -1 ? true : false;
            isAllTheSameUserCreate = this.isAllTheSameUser(s.listOrders);
          }

          if(s.created_date) {
            return {
              ...s,
              createdAt:  moment(s.created_date).format('YYYY-MM-DD HH:mm:ss'),
              statusOrder: true,
              hasFinishOrder,
              depositLabel
            }
          } else {
            return {
              ...s,
              statusOrder: false,
              hasFinishOrder,
              depositLabel,
              isAllTheSameUserCreate
            }
          }
        }))

        this.totalListOrder =  _.orderBy(totalListOrder, ['createdAt'], ['ASC']).reverse()
        // console.log('totalListOrder: ', totalListOrder)
      }
      else if(this.tab ==1 ){
        this.getInterviewsDetail();
        this.getNote()
      }
    },
    async clickCreateHistoryContact() {
      if (_.trim(this.note) == "") {
        this.reloadCreateNote = true;
        return;
      }
      const dataUpdate = {
        contactId: this.dataContact.id,
        description: _.trim(this.note),
      };
      let loading = this.$loading.show();
      const response = await ContactRepository.createContactHistory(
        dataUpdate,
        this.dataContact.id
      );
      loading.hide();
      if (response.error) {
        this.errorMessage = _.get(response, "message", "");
        this.$swal({
          type: "error",
          title: "Lỗi !",
          text: this.errorMessage,
        }).then(() => {});
        return;
      }
      this.note = " ";
      this.reloadCreateNote = false;
      this.getContactHistory();
    },
    async changeSelectStatus() {
      // return this.$swal({
      //   title: 'Bạn muốn thay đổi mối quan hệ ?',
      //   type: 'warning',
      //   showCancelButton: true,
      //   confirmButtonText: 'Đồng ý',
      //   closeOnConfirm: false,
      //   cancelButtonText: 'Huỷ Bỏ'
      // }).then(async result => {
      //   if (result.value) {
      this.isStatusChange = true;
      this.dataContact.statusId = this.statusId;
      return this.callAPIChangeStatus();
      // }
      this.statusId = this.dataContact.statusId;
      // });
    },
    async callAPIChangeStatus() {
      const dataUpdate = [
        {
          contactId: this.dataContact.id,
          statusId: this.statusId,
        },
      ];
      this.loading = this.$loading.show();
      const response = await ContactRepository.updateContactStatus(dataUpdate);
      this.loading.hide();
      if (response.error) {
        this.errorMessage = _.get(response, "message", "");
        this.$swal({
          type: "error",
          title: "Lỗi !",
          text: this.errorMessage,
        }).then(() => {});
      }
    },
    async changeSelectUser() {
      return this.$swal({
        title: "Bạn muốn thay đổi người phụ trách ?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Đồng ý",
        closeOnConfirm: false,
        cancelButtonText: "Huỷ Bỏ",
      }).then(async (result) => {
        if (result.value) {
          this.isStatusChange = true;
          if (!this.dataContact.user) {
            this.dataContact.user = {};
          }
          this.dataContact.user.id = this.userId;
          return this.callAPIChangeUser();
        }
        this.userId = _.get(this.dataContact, "user.id", "");
      });
    },
    async changeSelectUserMarketing() {
      return this.$swal({
        title: "Bạn muốn thay đổi nhân viên marketing ?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Đồng ý",
        closeOnConfirm: false,
        cancelButtonText: "Huỷ Bỏ",
      }).then(async (result) => {
        if (result.value) {
          this.isStatusChange = true;
          if (!this.dataContact.userMarketingName) {
            this.dataContact.userMarketingName = "";
          }
          this.dataContact.userMarketingName = this.userMarketingName;
          return this.callAPIChangeUserMarketing();
        }
        this.userMarketingName = _.get(
          this.dataContact,
          "userMarketingName",
          ""
        );
      });
    },
    async callAPIChangeUserMarketing() {
      const dataUpdate = {
        contactId: this.dataContact.id,
        userMarketingName: this.userMarketingName,
      };
      this.loading = this.$loading.show();
      const response = await ContactRepository.updateContactUserMarketing(
        dataUpdate
      );
      this.loading.hide();
      if (response.error) {
        this.errorMessage = _.get(response, "message", "");
        this.$swal({
          type: "error",
          title: "Lỗi !",
          text: this.errorMessage,
        }).then(() => {});
      }
    },
    async callAPIChangeUser() {
      const dataUpdate = [
        {
          contactId: this.dataContact.id,
          userId: this.userId,
        },
      ];
      this.loading = this.$loading.show();
      const response = await ContactRepository.updateContactUser(dataUpdate);
      this.loading.hide();
      if (response.error) {
        this.errorMessage = _.get(response, "message", "");
        this.$swal({
          type: "error",
          title: "Lỗi !",
          text: this.errorMessage,
        }).then(() => {});
      }
    },
    clickNewAppointment(dataContact) {
      const data = {
        contactId: dataContact.id,
        mobile: dataContact.mobile,
        fullName: dataContact.fullName,
        contactSources: dataContact.contactSources,
        from: "quickView",
        childCustomer: dataContact.childCustomer,
      };
      Bus.$emit("appointment-show-form-from-contact", data);
    },
    clickHistoryCall(mobile) {
      const routeData = this.$router.resolve({
        name: "CallCenterList",
        query: {
          keyword: mobile,
        },
      });
      window.open(routeData.href, "_blank");
    },
    async clickExecuteCall(dataContact, phone, isAutoScript = false) {
      if (this.isNormalCall) {
        const data = {
          mobile: phone,
          showCreateAppointment: false,
          contactId: dataContact.id,
          mainId: dataContact.mainId,
          mainMobile: dataContact.mobile,
        };
        Bus.$emit("voice-call-show-popup", data);
      } else {
        let body = {
          contactId: dataContact.id,
          type: this.selectedCallOptions.type,
          brandnameCode: this.selectedCallOptions.brandnameCode ? this.selectedCallOptions.brandnameCode : null,
        }
        if (isAutoScript) {
          body.type = 'auto';
          body.brandnameCode = null;
          this.SET_DEFAULT_TYPE_AUTO(1)
        } else {
          this.SET_DEFAULT_TYPE_AUTO(0)
        }
        let ext = ''
        let password = ''
        let callcenter_id = ''
        let group_id = ''
        let res = await ContactRepository.getCallInfo(body)
        if (res && res.success) {
          ext = res.data[0].ext;
          password = res.data[0].extPassword;
          callcenter_id = res.data[0].callcenterId;
          group_id = res.data[0].groupId;
        } else {
          if (_.get(res, 'errors.errorCode', null) == 4) {
            this.$swal({
              title: 'Thông báo!',
              text: _.get(res, 'errors.message', null)
            })
          } else {
            this.$swal({
              title: 'Thông báo!',
              text: 'Chưa có máy lẻ. Vui lòng liên hệ Sale Admin.'
            })
          }
          return
        }

        let data = {
          mobile: phone,
          showCreateAppointment: false,
          contactId: dataContact.id,
          callcenter_id: callcenter_id,
          mainId: dataContact.mainId,
          mainMobile: dataContact.phoneRelated[0],
          store: this.filterForm.store,
          groupId: group_id
        }
        if (callcenter_id == 1) {
          await Bus.$emit('init-epa-call-center', ext, password, data);
        } else if (callcenter_id == 2) {
          await Bus.$emit('init-care-soft-call-center', ext, data);
        } else if (callcenter_id == 4) {
          await Bus.$emit('init-ods-call-center', ext, password, data);
        }
      }
    },
    closeModal() {
      this.filterForm.openQuickViewMarketing = false;
      if (this.isStatusChange) {
        // this.searchContact();
      }
    },
    searchContact() {
      Bus.$emit("contact-list-filter", this.filterForm);
      Bus.$emit("contact-status-list");
    },
    checkShowNote() {
      this.checkAuthorization("contact_update")
        ? (this.showNote = true)
        : (this.showNote = false);
    },
    async deleteContactHistory(contactHistory) {
      this.$swal({
        title: "Xóa lịch sử",
        text: "Bạn có thực sự chắc chắn ?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Đồng ý",
        cancelButtonText: "Hủy bỏ",
      }).then(async (result) => {
        if (result.value) {
          const loader = this.$loading.show();
          let res = await ContactRepository.deleteContactHistory(
            contactHistory.id
          );
          loader.hide();
          if (res.success) {
            this.$swal({
              title: "Xóa thành công !",
              confirmButtonText: "Đồng ý",
            }).then(() => {
              this.getContactHistory();
            });
          } else {
            this.$swal({
              type: "error",
              title: "Lỗi !",
              text: _.get(res, "message", ""),
            });
          }
        }
      });
    },
    async updateContactHistory(contactHistory) {
      // this.loading = this.$loading.show()
      let res = await ContactRepository.updateContactHistory(
        contactHistory.id,
        {
          description: contactHistory.description,
        }
      );
      // this.loading.hide()
      if (res.success) {
        this.getContactHistory();
      } else {
        this.errorMessage = _.get(res, "message", "");
        this.$swal({
          type: "error",
          title: "Lỗi !",
          text: this.errorMessage,
        }).then(() => {});
        this.getContactHistory();
      }
    },
    async returnToBackStatus() {
      let loading = this.$loading.show();
      let response = await ContactRepository.returnToBackStatus(
        this.dataContact.id
      );
      loading.hide();
      if (response.error) {
        this.errorMessage = _.get(response, "message", "");
        this.$swal({
          type: "error",
          title: "Lỗi !",
          text: this.errorMessage,
        }).then(() => {});
        return;
      }
      this.dataContact.beforeSupport = null;
      this.getContactHistory();
    },
    showAppoimentAction(contact, phone) {
      const appointmentDetail = {
        id: contact.appointment.id,
        mainId: contact.mainId,
        mainMobile: contact.phoneRelated[0],
        customer: {
          contactId: contact.id,
        },
        mobile: phone,
      };
      Bus.$emit("appointment-show-form-from-action", appointmentDetail);
    },
    statusCallCenter() {
      return (
        this.checkAuthorization("call_center_read") ||
        this.checkAuthorization("call_center_view_all")
      );
    },
    editAppointment(contact) {
      const appointmentDetail = {
        id: contact.appointment.id,
        mainId: contact.mainId,
        mainMobile: contact.phoneRelated[0],
        customer: {
          contactId: contact.id,
        },
      };
      Bus.$emit("appointment-show-form-from-appointment", appointmentDetail);
    },
    checkContactSources(contactSources) {
      return showFbMessengerIcon(contactSources);
    },
    async getInterviewsDetail() {
      const res = await TutorTestRepository.getInterviewsDetail(
          this.contactQuickviewDetail.id
      );
      let sheduleInfo = _.get(res, "data");
      this.sheduleInfo = sheduleInfo.map((s) => {
        return {
          ...s,
          note: '',
        };
      });
    },
    async getNote() {
      let params = {
        action: "OPERATION",
      };
      const res = await TutorTestRepository.getNote(
          this.contactQuickviewDetail.id,
          params
      );
      let contactHistorys = res.data;
      this.tutorNoteHistory = contactHistorys.map((s) => {
        return {
          editable: false,
          ...s,
        };
      });
    },
    viewActiveCodes() {
      this.isActiveCodes = true;
    },
    async viewLogDGNL() {
      this.isPopupDGNL = true;
      const res = await ContactRepository.getListLogDGNL(this.dataContact.id, {});
      if (!res.success) {
        this.$swal({
          title: 'Lỗi !',
          text: _.get(res, 'message', ''),
          timer: 3000
        })
        return;
      }
      this.dataDGNL = res.data;
    },
    closePopupDGNL() {
      this.isPopupDGNL = false;
      this.dataDGNL = [];
    },
    async getActionLogTypeList() {
      if (this.$store.state.listActionLogType) {
        this.actionLogTypeList = this.$store.state.listActionLogType;
        // return;
      } else {
        const res = await CoreActionsLogRepository.listActionLogType();
        if (res.success) {
          this.actionLogTypeList = _.get(res, 'data', [])
        }
        if (this.actionLogTypeList && this.actionLogTypeList.length) {
          this.$store.dispatch('SET_LIST_ACTION_LOG_TYPE', this.actionLogTypeList)
        }
      }

      this.actionLogTypeList.forEach(item => {
        if (!this.mapNamePointActionLog[item.name]) {
          this.mapNamePointActionLog[item.name] = item.point
        }
      })
    },
    getDepositLabel(listOrder) {
      if (listOrder.every(item => namesOrderContactStatusTc.includes(item.contactStatus.name.toUpperCase())) && listOrder.some(item => item.orderType == ORDER_FINISH_TYPE)) {
        return 'Đã hoàn thành phí'
      } else if (listOrder.some(item => namesOrderContactStatusTc.includes(item.contactStatus.name.toUpperCase()))) {
        return 'Đã thanh toán 1 phần'
      } else {
        return 'Chưa thanh toán';
      }
    },
    isAllTheSameUser(listOrder) {
      if (!listOrder) return true;
      let userId = _.get(listOrder[0], 'userId', null);
      for (let k = 1; k < listOrder.length; k++) {
        if (listOrder[k].userId != userId) {
          return false
        }
      }
      return true
    },
    async getCurriculums() {
      const params = `getCurriculums.type_contact_id.${this.dataContact.typeId}`
      const res = await ContactRepository.getListCurriculum(params);
      this.curriculums = _.get(res, 'data', []) || [];
      this.curriculums = _.chain(this.curriculums)
          .filter(item => item.test_type.length)
          .filter(item => !item.type_school_level_id.length || item.type_school_level_id.includes(this.dataContact.schoolLevelId))
          .value();
    },
    async getTagsContact() {
      const params = {
        obj: "contact_tags",
        "filters[$eq__contactId]" : this.dataContact?.id,
        attrs: ["id", "tagCode", "tagIcon", "tagName", "tagColor", "data"]
      }
      const response = await ContactRepository.getListTags(params);
      this.tagByContact = _.get(response, 'data')
    },
    openLink(tag) {
      if(tag.tagCode == 'BaoCaoHocThuDUO'){
        this.showPopupTryLession = true
      }
      if (tag.tagCode == 'OnboardingConversation') {
        this.showIeltsOnboarding = true
        return;
      }
      if (!tag.data) return;
      const link = JSON.parse(tag.data);
      window.open(link.result_link, '_blank');
    },
    showModalZaloZns () {
      this.isShowZaloZns = true
    }
  },
};
</script>

<style scoped>
/deep/ .v-subheader.theme--light {
  font-size: 10px;
  font-weight: bold;
}

.contact-history-table--wrapper {
  max-height: 280px;
  overflow: auto;
}

/deep/ .v-tabs-bar {
  height: 30px;
}

/deep/ .v-tab {
  font-size: 12px;
}

.appointment-time-wrapper {
  padding: 5px;
  border: 1px solid #a9a9a9;
  border-radius: 5px;
  font-weight: 700;
}
.class-list {
  background: #F7F7FC;
  overflow: auto;
  max-height: 400px;
}
</style>
